import { ActionTree } from "vuex/types/index";

import { SohoModel } from "~/constants/SohoModel";
import { RequestParameters } from "~/utils/SohoApi/SohoApi";
import { setIncludedResources } from "~/utils/store";

import { RootState } from "../store.types";
import { VenuesState, Venue, VenuesFilter, VenueResource } from "./venues.types";

const actions: ActionTree<VenuesState, RootState> = {
  async fetchVenues ({ commit }, params: RequestParameters<Venue, VenuesFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<VenueResource>(SohoModel.Venue, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_VENUES", { params, data })
    }
  }
}

export default actions
